import { render, staticRenderFns } from "./HashTags.vue?vue&type=template&id=47ed4628"
import script from "./HashTags.vue?vue&type=script&lang=js"
export * from "./HashTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports